import React from 'react';
import ProductDocumentationCard from '../Components/ProductDocumentationCard';
import { __ } from '../../../Utils';
import { connect, actions } from '../../../Store';
import BaseList from '../BaseList';
import AlertPopup from '../../../Components/AlertPopup';
import API2 from '../../../API2';

class Documentations extends BaseList {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      title: __('Technická dokumentácia'),
      notFoundMessage: __('Ľutujeme dokumenty sa nenašli '),
      isProduct: true,
      cartItemsIds: [],
      cartItems: [],
      maxFilterWidth: 140,
      defaultFilter: [
        {
          id: 'type',
          values: ['documentation'],
        },
      ],
    };

    actions.setActiveMenuItem('74');
  }

  componentDidMount() {
    this.init();
  }

  async downloadFileWithId(downloadId) {
    window.location.href = downloadId;

    this.setState({
      downloadUrl: undefined,
    });
  }

  init() {
    const {
      actualPage,
      checkedFilter,
      offset,
      nextOffset,
      total,
      searchText,
    } = this.loadActualData();

    const newSearchText =
      searchText &&
      searchText !== null &&
      searchText !== 'null' &&
      searchText !== 'undefined'
        ? searchText
        : '';

    let newCheckedFilter =
      checkedFilter && checkedFilter !== 'undefined'
        ? JSON.parse(checkedFilter)
        : [];

    if (!newCheckedFilter || newCheckedFilter.length === 0) {
      newCheckedFilter = this.state.defaultFilter;
    }

    this.setState(
      {
        actualPage:
          actualPage &&
          actualPage !== null &&
          actualPage !== 'null' &&
          actualPage > 0
            ? Number(actualPage)
            : 1,
        offset:
          offset && offset !== null && offset !== 'null' && offset > 0
            ? Number(offset)
            : 0,
        searchText: newSearchText,
        defaultSearchText: newSearchText,
        nextOffset:
          nextOffset &&
          nextOffset !== null &&
          nextOffset !== 'null' &&
          nextOffset > 0
            ? Number(nextOffset)
            : 0,
        total:
          total && total !== null && total !== 'null' && total > 0
            ? Number(total)
            : 0,
        checkedFilter: newCheckedFilter,
      },
      async () => {
        await this.fetchFilter(!checkedFilter || checkedFilter.length === 0);
        this.fetchData({
          offset:
            offset && offset !== null && offset !== 'null' && offset > 0
              ? Number(offset)
              : 0,
          total,
        });
        this.saveActualData(1, 0, null, [], null);
      },
    );
  }

  async downloadFile(id) {
    try {
      const result = await API2.getB2BDocumentationDownloadAction(id);
      this.setState({
        downloadUrl: result.url,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async downloadFiles(ids) {
    try {
      const result = await API2.getB2BDocumentationDownloadZipAction({
        documentationIds: ids,
      });
      this.setState({
        downloadUrl: result.url,
      });
    } catch (e) {
      console.log(e);
    }
  }

  async fetchData(parameters = {}) {
    const { limit, checkedFilter, searchText } = this.state;

    try {
      const params = parameters;

      if (checkedFilter) {
        params.filters = {};
        const str = JSON.stringify({ filter: checkedFilter });
        params.filters = str;
      }

      if (searchText && searchText.length > 0) {
        params.q = searchText;
      }

      const newData = await API2.getB2BDocumentationAction(
        Object.assign(params, { limit }),
      );

      this.setState({
        items: newData.documentations,
        loading: false,
        filtersDisabled: false,
        limit: newData.limit,
        offset: newData.offset,
        total: newData.total,
        nextOffset: newData.next_offset,
      });
    } catch (e) {
      console.log(e);
    }
  }

  updateCartItems(cartItems) {
    this.setState({
      cartItems,
      cartItemsIds: cartItems.map(item => {
        return item.product_id;
      }),
    });
  }

  openProduct(id) {
    this.props.history.push(`/catalog/list/${id}`);
  }

  renderItemsList() {
    const { items } = this.state;

    return items.map(p => {
      return (
        <ProductDocumentationCard
          history={this.props.history}
          downloadFile={id => this.downloadFile(id)}
          downloadFiles={ids => this.downloadFiles(ids)}
          title={__('Dokumentácia')}
          onProductClick={id => this.openProduct(id)}
          firm={this.props.firm}
          data={p}
        />
      );
    });
  }

  render() {
    const { downloadUrl } = this.state;
    return (
      <React.Fragment>
        <AlertPopup
          alignUnderHeader
          display={downloadUrl}
          style
          onClose={() =>
            this.setState({
              downloadUrl: undefined,
            })
          }
          scrollContent
          question
          text={__(`Prajete si uložiť súbor`)}
          onSubmit={() => this.downloadFileWithId(downloadUrl)}
          onDismiss={() =>
            this.setState({
              downloadUrl: undefined,
            })
          }
        />

        {super.render()}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(Documentations);



// WEBPACK FOOTER //
// ./src/Containers/ProductCatalog/Documentations/index.jsx